import * as Yup from "yup";
import {
  emailValidationRegex,
  phoneNumberRegex,
  faxNumberRegex,
  websiteUrlRegex,
  zipCodeRegex,
} from "../../../../../../../constants/regexStrings";
import phoneValidation from "../../../../../../../common/components/phone-number-input-component/phone-validation";
import { isOnlyCountryCode } from "../../../../../../../utils/utils";
export const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  primaryPhoneNumber: "",
  designation:""
};

export const validationSchema = (isEditMode: boolean) =>
  Yup.object().shape({
    firstName: Yup.string().required("First Name cannot be empty"),
    lastName: isEditMode
      ? Yup.string()
      : Yup.string().required("Last Name cannot be empty"),
    email: Yup.string()
      .matches(emailValidationRegex, "Please enter a valid Email address")
      .required("Email cannot be empty")
      .max(150, "Email cannot be more than 150 characters"),

    primaryPhoneNumber: Yup.string()
      .test(
        "is-valid-phone",
        "Please enter a valid phone number",
        function (value: any) {
          if (isOnlyCountryCode(value)) {
            return true;
          }
          return phoneValidation(value);
        }
      )
      .nullable(),
      
  });
